<template>
  <b-modal ref="editItemModal"
           id="modal-edit-question"
           title="Редактировать вопрос"
           hide-footer>
      <b-form @submit="onSubmit" @reset="onReset" class="w-100">
      <alertMsg :message="alertMessage" v-if="showAlert"></alertMsg>
      <b-form-group id="form-title-group-question">
        <b-form-input id="question"
                        type="text"
                        placeholder="Введите вопрос"
                        v-model="editForm.question"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-options">
        <b-form-input id="options"
                        type="text"
                        placeholder="Введите варианты ответа"
                        v-model="editForm.options"
                        required>

        </b-form-input>
      </b-form-group>
      <b-button type="submit" variant="success">Изменить</b-button>
      <b-button type="reset" variant="">Отмена</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import alertMsg from '../common/AlertMsg';

export default {
  components: {
    alertMsg,
  },
  name: 'modalEdit',
  data() {
    return {
      editForm: {
        question: '',
        options: '',
      },
      alertMessage: 'Error',
      showAlert: false,
      groups: [],
    };
  },
  computed: {
    ...mapState({
      editing_item: state => state.quizes.editing_item,
      host: state => state.host,
    }),
    isAuthorised() {
      return this.$store.getters.isAuthorised;
    },
  },
  methods: {
    ...mapActions([
      'alertMsg', // -> this.alertMsg()
    ]),
    editItem(payload) {
      this.showAlert = false;
      const id = 'modal-edit-question';
      const path = this.host + 'edit_question';
      axios.post(path, payload, { headers: { 'Content-Type': 'application/json' } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.$bvModal.hide(id);
            this.$emit('question');
            this.alertMsg({
              alert: res.data.message,
              type: 'success',
            });
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      let payload = {
        'id' : this.editing_item.id,
        'options' : this.editing_item.options,
        'question' : this.editing_item.question,
      };
      this.editItem(payload);
      // eslint-disable-next-line
      console.log(payload);
    },
    onReset(evt) {
      evt.preventDefault();
      this.$bvModal.hide('modal-edit-question');
      this.initForm();
    },
    initForm() {
      this.editForm.question = this.editing_item.question;
      this.editForm.options = this.editing_item.options;
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === 'modal-edit-question'){
        this.initForm();
      }
    })
  },
};
</script>

<style scoped>

</style>
